<template>
    <div class="scroll-wrap" v-bar>
        <div class="container"  ref="scrollBar" id="scrollBar" @scroll="onScroll">
            <div class="article-page" id="article3">
                <div class="closer"><route-item :to="'/main'" :element="'main'"
                                                @click.native="gaEvents('article3','click','go down')"></route-item>
                </div>
                <div class="social-share social-block" :class="{'open': openSocial}">
                    <ul class="social-list" v-if="openSocial">
                        <li>
                            <share-link network="fb"
                                url="http://weleda.afisha.ru/share"
                                title="Природная гармония в Швебиш-Гмюнде"
                                image="/static/img/share/share3.jpg"
                                description="Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики."
                                article="/article3"
                                @click.native="gaEvents('article3','click','fb')"
                                class="icon">
                                <fb></fb>
                            </share-link>
                        </li>
                        <li>
                            <share-link network="vk"
                                url="http://weleda.afisha.ru/share"
                                title="Природная гармония в Швебиш-Гмюнде"
                                image="/static/img/share/share3.jpg"
                                description="Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики."
                                article="/article3"
                                @click.native="gaEvents('article3','click','vk')"
                                class="icon">
                                <vk></vk>
                            </share-link>
                        </li>
                        <li>
                            <share-link network="ok"
                                url="http://weleda.afisha.ru/share"
                                title="Природная гармония в Швебиш-Гмюнде"
                                image="/static/img/share/share3.jpg"
                                description="Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики."
                                article="/article3"
                                @click.native="gaEvents('article3','click','ok')"
                                class="icon">
                                <ok></ok>
                            </share-link>
                        </li>
                        <li>
                            <share-link network="tw"
                                url="http://weleda.afisha.ru/share"
                                title="Природная гармония в Швебиш-Гмюнде"
                                image="/static/img/share/share3.jpg"
                                description="Уникальный сад, где цветут тысячи лекарственных растений, которые используются в производстве натуральной косметики."
                                article="/article3"
                                @click.native="gaEvents('article3','click','tw')"
                                class="icon">
                                <tw></tw>
                            </share-link>
                        </li>
                    </ul>
                    <a href="#" class="open-social" @click.prevent="toggleSocial">
                        <p>Поделиться</p>
                        <opensocial></opensocial>
                    </a>
                </div>
                <div class="wrapper">
                    <h2 class="head">
                        Природная гармония <br> в Швебиш-Гмюнде
                    </h2>

                    <div class="video">
                        <div class="video-bg" v-if="!isPlaying"></div>
                        <div class="dplayer-bezel-icon" v-if="!isPlaying" @click="playVideo" ref="button"></div>
                        <youtube player-width="560"
                                 player-height="315"
                                 :video-id="'TZBmTiKCZ9U'"
                                 :player-vars="{autoplay: 0,controls: 0, showinfo: 0,rel: 0}"
                                 @ready="ready"
                                 @ended="ended"
                        ></youtube>
                    </div>

                    <div class="quotes">
                <span class="text">Швебиш-Гмюнд — очень милый небольшой городок с пряничными домиками, в пригороде которого есть сказочный сад. Тот самый, где вот уже почти сто лет создают истинно натуральную косметику</span>
                    </div>
                    <div class="content">
                        <p>
                            Небольшой старинный городок в пятидесяти километрах от Штутгарта редко попадает в новости — разве что местный фермер получит приз за самую симпатичную овцу в земле Баден-Вюртемберг.                         </p>
                        <p>
                            Швебиш-Гмюнд — образец покоя и стабильности: жизнь здесь течет размеренно, в соответствии с сезонами и естественными ритмами природы.                        </p>
                        <p>
                            В этом смысле биодинамический сад Weleda на севере города можно считать совершенно «швебиш-гмюндским» предприятием — жизнь его абсолютно подчинена природной логике.
                        </p>

                        <p>
                            Из всех европейских садов компании тот, что в Германии, — самый большой и биологически разнообразный: 23 га земли и 1000 видов растений, в том числе 140 лекарственных — последние выращивают для производства медицинских препаратов и натуральных косметических продуктов.
                        </p>

                        <p>
                            Так, большую часть календулы, которые Weleda использует в своих средствах, собирают и перерабатывают, превращая в спиртовую вытяжку и масляный экстракт, именно здесь.
                            Помимо узнаваемых оранжевых цветов, на открытых полях растет множество однолетних и многолетних культур — терн, гамамелис, эхинацея, боярышник, дудник, чистотел и многие другие.
                        </p>
                    </div>
                </div>
                <div class="slider">
                    <swiper :options="swiperOption">
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide1.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide2.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide3.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide4.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide5.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide6.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide7.jpg" alt="">
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="slide-content">
                                <img src="static/img/article2/slides/slide8.jpg" alt="">
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev custom-arrow-prev"></div>
                    <div class="swiper-button-next custom-arrow-next"></div>
                </div>

                <div class="wrapper">
                    <div class="quotes">
                        <span class="text">
                            В этом саду царит атмосфера любви, счастья и умиротворения, что передается через растения косметике. Все растения в этом саду целебные, даже листья березы
                        </span>
                    </div>
                    <div class="content">
                        <p>
                            Для обработки почвы фермеры и садоводы используют только те компоненты, которые образовались естественным путем, а значит, несут в себе энергию природы.
                        </p>
                        <p>
                            У любого растения и животного в саду Weleda есть своя продуманная ниша: горец, например, служит своеобразным зонтиком для папоротника, который любит тень и прохладу.
                        </p>
                    </div>

                    <div class="quotes">
                        <span class="text">
                            Этот сад лекарственных растений — крупнейший биодинамический сад в Европе. При производстве используется лишь натуральное сырье и неизменная рецептура
                        </span>
                    </div>

                    <div class="img-content">
                        <div class="img">
                            <img src="static/img/article2/inner-img1.jpg" class="img1" alt="">
                        </div>
                        <div class="desc">
                            <p>
                                Здесь же у компании самое крупное производство — некоторые травы и цветы, попадая в продукты марки, не всегда успевают осознать разлуку с землей, настолько свежее у компании сырье, и только подобным образом полезные вещества и компоненты растений могут сохранить свои ценные качества. Все растения собираются максимально быстро и вручную, при этом запрещено использование электрического тока и воздействие электромагнитного излучения.
                            </p>
                            <p>
                                Словом, к выращиванию растений, их сбору и финальному этапу производства здесь относятся максимально бережно, ведь именно это лежит в основе принципов Weleda — сохраняя природу, создавать натуральную косметику, наполненную силой и энергией тысячи растений.
                            </p>
                        </div>
                    </div>

                    <div class="products-block mobile-hidden">
                        <div class="product-item">
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','1-Массажное масло с арникой')"></a>
                            <div class="img">
                                <img src="static/img/product/product7.png" alt="">
                            </div>
                            <span class="item-head">
                                Деликатное <br> питательное <br> масло для лица
                            </span>
                            <span class="item-desc">
                                Гармония и гладкость кожи
                            </span>
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                        <span class="text">
                            Подробнее
                        </span>
                            </a>
                        </div>
                        <div class="product-item">
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','2-Цитрусовый освежающий гель для душа')"></a>
                            <div class="img">
                                <img src="static/img/product/product8.png" alt="">
                            </div>
                            <span class="item-head">
                                Деликатный <br> увлажняющий крем
                            </span>
                            <span class="item-desc">
                                Лёгкий увлажняющий крем <br> для ухода за чувствительной кожей
                            </span>
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                        <span class="text">
                            Подробнее
                        </span>
                            </a>
                        </div>
                        <div class="product-item">
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','3-Универсальный питательный крем SKIN FOOD')"></a>
                            <div class="img">
                                <img src="static/img/product/product9.png"  alt="">
                            </div>
                            <span class="item-head">
                        Универсальный <br>питательный крем <br>SKIN FOOD
                    </span>
                            <span class="item-desc">
                                Интенсивно ухаживает за сухой и обезвоженной кожей лица, рук и тела
                            </span>
                            <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                        <span class="text">
                            Подробнее
                        </span>
                            </a>
                        </div>
                    </div>

                    <div class="products-block desktop-hidden">
                        <swiper :options="swiperProductOption">
                            <swiper-slide>
                                <div class="product-item">
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','1-Массажное масло с арникой')"></a>
                                    <div class="img">
                                        <img src="static/img/product/product7.png" alt="">
                                    </div>
                                    <span class="item-head">
                                        Деликатное <br> питательное <br> масло для лица
                                    </span>
                                    <span class="item-desc">
                                        Гармония и гладкость кожи
                                    </span>
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D0%BE%D0%B5-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D0%BE%D0%B5-%D0%BC%D0%B0%D1%81%D0%BB%D0%BE-%D0%B4%D0%BB%D1%8F-%D0%BB%D0%B8%D1%86%D0%B0?utm_source=afisha&utm_medium=longread&utm_content=face_oil&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                        <span class="text">
                                            Подробнее
                                        </span>
                                    </a>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="product-item">
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','2-Цитрусовый освежающий гель для душа')"></a>
                                    <div class="img">
                                        <img src="static/img/product/product8.png" alt="">
                                    </div>
                                    <span class="item-head">
                                        Деликатный <br> увлажняющий крем
                                    </span>
                                            <span class="item-desc">
                                        Лёгкий увлажняющий крем <br> для ухода за чувствительной кожей
                                    </span>
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D0%B4/%D0%B4%D0%B5%D0%BB%D0%B8%D0%BA%D0%B0%D1%82%D0%BD%D1%8B%D0%B9-%D1%83%D0%B2%D0%BB%D0%B0%D0%B6%D0%BD%D1%8F%D1%8E%D1%89%D0%B8%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC?utm_source=afisha&utm_medium=longread&utm_content=moisture&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                        <span class="text">
                                            Подробнее
                                        </span>
                                    </a>
                                </div>
                            </swiper-slide>
                            <swiper-slide>
                                <div class="product-item">
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link-item" @click="gaEvents('longread','click','3-Универсальный питательный крем SKIN FOOD')"></a>
                                    <div class="img">
                                        <img src="static/img/product/product9.png"  alt="">
                                    </div>
                                    <span class="item-head">
                                        Универсальный <br>питательный крем <br>SKIN FOOD
                                    </span>
                                    <span class="item-desc">
                                        Интенсивно ухаживает за сухой и обезвоженной кожей лица, рук и тела
                                    </span>
                                    <a href="https://www.weleda.ru/%D0%BF%D1%80%D0%BE%D0%B4%D1%83%D0%BA%D1%82/%D1%83/%D1%83%D0%BD%D0%B8%D0%B2%D0%B5%D1%80%D1%81%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BF%D0%B8%D1%82%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D0%BD%D1%8B%D0%B9-%D0%BA%D1%80%D0%B5%D0%BC-skin-food?utm_source=afisha&utm_medium=longread&utm_content=skin_food&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="link">
                                        <span class="text">
                                            Подробнее
                                        </span>
                                    </a>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <div class="swiper-pagination"></div>
                    </div>
                </div>
                <div class="check">
                    <div class="footnote"><p>*Веледа,Скин фуд</p></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import  articleMix from '@/components/pages/articles/article_mix.vue';
    import DPlayer from 'DPlayer';

    export default {
        name: 'article3',
        mixins: [articleMix],
        data() {
            return {
                isPlaying: false,
                player: ''
            }
        },
        methods: {
            ready(e) {
                this.canPlay = true;
                this.player = e.target;
            },
            ended() {
                this.isPlaying = false;
            },
            playVideo() {
                this.isPlaying = true;
                if(this.canPlay){
                    this.$root.gaSend('play','click','longread 3')
                    this.player.playVideo();
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// article3.vue?2efe2f0f